/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createWall = /* GraphQL */ `
  mutation CreateWall(
    $input: CreateWallInput!
    $condition: ModelWallConditionInput
  ) {
    createWall(input: $input, condition: $condition) {
      id
      status
      senderId
      senderName
      occasion
      layout
      config
      greetingType
      passcode
      createdAt
      cards {
        items {
          id
          text
          cardName
          senderId
          senderName
          wallID
          createdAt
          updatedAt
        }
        nextToken
      }
      recipients {
        items {
          id
          recipientId
          recipientName
          wallID
          createdAt
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const updateWall = /* GraphQL */ `
  mutation UpdateWall(
    $input: UpdateWallInput!
    $condition: ModelWallConditionInput
  ) {
    updateWall(input: $input, condition: $condition) {
      id
      status
      senderId
      senderName
      occasion
      layout
      config
      greetingType
      passcode
      createdAt
      cards {
        items {
          id
          text
          cardName
          senderId
          senderName
          wallID
          createdAt
          updatedAt
        }
        nextToken
      }
      recipients {
        items {
          id
          recipientId
          recipientName
          wallID
          createdAt
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const deleteWall = /* GraphQL */ `
  mutation DeleteWall(
    $input: DeleteWallInput!
    $condition: ModelWallConditionInput
  ) {
    deleteWall(input: $input, condition: $condition) {
      id
      status
      senderId
      senderName
      occasion
      layout
      config
      greetingType
      passcode
      createdAt
      cards {
        items {
          id
          text
          cardName
          senderId
          senderName
          wallID
          createdAt
          updatedAt
        }
        nextToken
      }
      recipients {
        items {
          id
          recipientId
          recipientName
          wallID
          createdAt
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const createWallCard = /* GraphQL */ `
  mutation CreateWallCard(
    $input: CreateWallCardInput!
    $condition: ModelWallCardConditionInput
  ) {
    createWallCard(input: $input, condition: $condition) {
      id
      text
      cardName
      senderId
      senderName
      wallID
      createdAt
      wall {
        id
        status
        senderId
        senderName
        occasion
        layout
        config
        greetingType
        passcode
        createdAt
        cards {
          nextToken
        }
        recipients {
          nextToken
        }
        updatedAt
      }
      updatedAt
    }
  }
`;
export const updateWallCard = /* GraphQL */ `
  mutation UpdateWallCard(
    $input: UpdateWallCardInput!
    $condition: ModelWallCardConditionInput
  ) {
    updateWallCard(input: $input, condition: $condition) {
      id
      text
      cardName
      senderId
      senderName
      wallID
      createdAt
      wall {
        id
        status
        senderId
        senderName
        occasion
        layout
        config
        greetingType
        passcode
        createdAt
        cards {
          nextToken
        }
        recipients {
          nextToken
        }
        updatedAt
      }
      updatedAt
    }
  }
`;
export const deleteWallCard = /* GraphQL */ `
  mutation DeleteWallCard(
    $input: DeleteWallCardInput!
    $condition: ModelWallCardConditionInput
  ) {
    deleteWallCard(input: $input, condition: $condition) {
      id
      text
      cardName
      senderId
      senderName
      wallID
      createdAt
      wall {
        id
        status
        senderId
        senderName
        occasion
        layout
        config
        greetingType
        passcode
        createdAt
        cards {
          nextToken
        }
        recipients {
          nextToken
        }
        updatedAt
      }
      updatedAt
    }
  }
`;
export const createWallRecipient = /* GraphQL */ `
  mutation CreateWallRecipient(
    $input: CreateWallRecipientInput!
    $condition: ModelWallRecipientConditionInput
  ) {
    createWallRecipient(input: $input, condition: $condition) {
      id
      recipientId
      recipientName
      wallID
      createdAt
      wall {
        id
        status
        senderId
        senderName
        occasion
        layout
        config
        greetingType
        passcode
        createdAt
        cards {
          nextToken
        }
        recipients {
          nextToken
        }
        updatedAt
      }
      updatedAt
    }
  }
`;
export const updateWallRecipient = /* GraphQL */ `
  mutation UpdateWallRecipient(
    $input: UpdateWallRecipientInput!
    $condition: ModelWallRecipientConditionInput
  ) {
    updateWallRecipient(input: $input, condition: $condition) {
      id
      recipientId
      recipientName
      wallID
      createdAt
      wall {
        id
        status
        senderId
        senderName
        occasion
        layout
        config
        greetingType
        passcode
        createdAt
        cards {
          nextToken
        }
        recipients {
          nextToken
        }
        updatedAt
      }
      updatedAt
    }
  }
`;
export const deleteWallRecipient = /* GraphQL */ `
  mutation DeleteWallRecipient(
    $input: DeleteWallRecipientInput!
    $condition: ModelWallRecipientConditionInput
  ) {
    deleteWallRecipient(input: $input, condition: $condition) {
      id
      recipientId
      recipientName
      wallID
      createdAt
      wall {
        id
        status
        senderId
        senderName
        occasion
        layout
        config
        greetingType
        passcode
        createdAt
        cards {
          nextToken
        }
        recipients {
          nextToken
        }
        updatedAt
      }
      updatedAt
    }
  }
`;
